class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHoverOpen();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Toggle solid header when mega menu opens over transparent header
    if (this.mainDetailsToggle.open) {
      this.header.classList.add('header-wrapper--mega-open');
    } else {
      // Check if any other header-menu is still open
      const anyOpen = document.querySelectorAll('header-menu details[open]');
      if (anyOpen.length === 0) {
        this.header.classList.remove('header-wrapper--mega-open');
      }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  setupHoverOpen() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

    this.addEventListener('mouseenter', () => {
      if (this.closeTimeout) clearTimeout(this.closeTimeout);
      if (this.mainDetailsToggle.open) return;

      // Close any other open header menus first
      document.querySelectorAll('header-menu details[open]').forEach((d) => {
        if (d !== this.mainDetailsToggle) {
          d.removeAttribute('open');
          d.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });

      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    });

    this.addEventListener('mouseleave', () => {
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, 200);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
